import $ from 'jquery'
//import async from 'async'

let _p = window.xwCommon,
  	_this = {
	  	title:"消息中心",
	  	name:"car_user_msg",
	  	readList(vm,p,s){
	        let url = _p.getApiUrl("push/list"),
	            page = p || vm.currentPage, page_size = s || vm.pageSize,
	            paging = true, is_read = (vm.msgType > -1)? vm.msgType : undefined
	        vm.loading = true
	        $.post(url,{ page, page_size, paging, is_read },(json) => _this.fillData(vm, json))
	    },
	  	fillData(vm, json){
	        //console.log(arguments)
	        let status = parseInt(json.status)
	        if(200 !== status){
	          switch(status){
	            default: 
	              if(_p.checkAjaxStatus(vm,json,_this.title)) break;
	              vm.$alert(json.msg,_this.title);
	              break;
	          }
	          return;
	        } else {
	          vm.$nextTick(() => {
	          	//console.log(json)
	            vm.tableData = json.data.data
	            vm.currentPage = parseInt(json.data.current_page)
	            vm.totalRow = parseInt(json.data.total)
	            vm.pageSize = parseInt(json.data.per_page)
	            vm.loading = false
	          })
	          
	        }
      	},
      	showMsgWin(vm, obj){
      		let func = () => {
      			vm.$set(vm.msgDialog,"msg",obj.msg_content)
      			vm.$set(vm.msgDialog,"visible",true)
      		}
      		if(obj.is_read == 0){
      			_this.setRead(vm,obj.push_msg_id).then(() => {
      				func()
      				_this.readList(vm)
      			}, (json) => _p.promiseErrorChecker(vm, json, _this.title))
      		}else{
      			func()
      		}
      	},
      	setRead(vm, push_msg_id){
      		let u = _p.getApiUrl("push/setRead"), user = _p.getStoredProp("staff/query"), staff_id = user.staff_id, 
      			func = (callback,reject) => {
      				$.get(u,{ push_msg_id, staff_id },(json) => {
						let status = parseInt(json.status);
						switch(status){
							case 200:
								callback(json.data);
								break;
							default:
								reject(json);
								break;
						}
						//console.log(json);
					})
      			}
      		return new Promise(func)
      	},
      	showNotifyMsg(vm, obj, title){
      		let content = obj, icon = "/static/img/avatar.png", shown = false
      		if($.isPlainObject(obj)){
      			content = obj.msg
      		}
      		if(_p.isNull(title)){
      			title = "推送消息"
      		}
      		if (window.webkitNotifications) {
      			if (window.webkitNotifications.checkPermission() == 0) {
      				let msgWin = window.webkitNotifications.createNotification(icon, title, content);
      				msgWin.onclick = function() { _this.msgJumpTo(vm,obj); msgWin.cancel(); } 
      				msgWin.replaceId = 'Meteoric';  
                	            msgWin.show();
                	            shown = true
      			} 
      		}
      		else if("Notification" in window){
            		if (Notification.permission === "granted") {  
      	                let msgWin = new Notification(title, { icon, "body": content });
      	                msgWin.onclick = function(e) { _this.msgJumpTo(vm,obj); msgWin.close(); }
      	                shown = true
      	            } 
      		}

                  if(shown){
                        let notifyCheck = sessionStorage.getItem('NotifyGranted')
                        notifyCheck = _p.isNull(notifyCheck)? 0 : parseInt(notifyCheck)
                        sessionStorage.setItem('NotifyGranted',notifyCheck)
                  } else {
      			let msgWin = vm.$notify({
		                title, message: content, duration: 0, onClick: () => { _this.msgJumpTo(vm,obj); msgWin.close(); }
		            });
      		}
      	},
      	msgJumpTo(vm,obj){
      		vm.$bus.emit('push-router',{name:"car_user_msg"})
      	},
      	checkMsg(vm){
			// console.log(vm);
      		//if(!_this.counter)_this.counter = 1;
      		//vm.$bus.emit("receiveMsg", _this.counter++)
      		let u = _p.getApiUrl("push/lastEst"), user = _p.getStoredProp("staff/query"), staff_id = user.staff_id
      		$.get(u,{ staff_id },(json) => {
				let status = parseInt(json.status)
				if(200 !== status){
					switch(status){
			            default: 
			              if(_p.checkAjaxStatus(vm,json,_this.title)) break;
			              //vm.$alert(json.msg,_this.title);
							vm.login = false;
							//vm.$bus.emit('push-router',"/login");
							window.location.reload;
			              break;
			        }
			        return;
				}else{
					if(json.data && json.data.msg){
						vm.$bus.emit("receiveMsg", json.data)
					}
				}
			})
      		//console.log(user)
      	},
      	stop(vm){
      		clearInterval(_p.notifyTimer)
                  vm.$bus.off("receiveMsg")
      	},
      	start(vm){
      		let noCheck = parseInt(sessionStorage.getItem('noNotifyCheck')),
      			noTimer = parseInt(sessionStorage.getItem('noNotifyTimer')),
      			func = function(ret){
	      			if(ret == "granted"){
                                    vm.$message('桌面推送功能已启动！');
	      			}else{
	      				if(window.webkitNotifications && window.webkitNotifications.checkPermission() == 0){
	      					vm.$notify({title:"启用桌面推送","message":"桌面推送功能已启动！"});
                                          sessionStorage.setItem('NotifyGranted',1)
	      				}else{
	      					vm.$alert("您拒绝了桌面推送功能，相关推送消息将显示在本页面右侧！","启用桌面推送");
	      					sessionStorage.setItem('noNotifyCheck',1)
	      				}
	      			}
	      		}
	      	if(noTimer != 1){
				//   alert(msg)
                        //console.log("kaaa")
	      		vm.$bus.on("receiveMsg",(msg) => {
					  alert(msg)
					  _this.showNotifyMsg(vm,msg)}
					)
                        _this.checkMsg(vm)
      			_p.notifyTimer = setInterval(() => _this.checkMsg(vm),_p.config.checkTimer*1000)
	      	}
      		if(noCheck == 1){
                        //console.log("bbb")
      			return;
      		}
      		if (window.webkitNotifications) {
      			if (window.webkitNotifications.checkPermission() != 0) {
      				//window.webkitNotifications.requestPermission(cb)
      				vm.$alert('您尚未启用桌面推送功能，请关闭此窗口后根据上方弹窗提示操作！', '启用桌面推送', {
      					callback:() => {
      						window.webkitNotifications.requestPermission(func)
      					}
      				})
      			}else{
                              sessionStorage.setItem('NotifyGranted',1)
                        }
      		}else if("Notification" in window) {
      			if(Notification.permission != "granted"){
      				//Notification.requestPermission()
      				// vm.$alert('您尚未启用桌面推送功能，请关闭此窗口后根据上方弹窗提示操作！', '启用桌面推送', {
      				// 	callback:() => {
      				// 		Notification.requestPermission().then(func)
      				// 	}
      				// })
                              Notification.requestPermission().then(func)
      			}else{
                              sessionStorage.setItem('NotifyGranted',1)
                        }
      		}
                  let notifyCheck = parseInt(sessionStorage.getItem('NotifyGranted'))
                  if(notifyCheck > 0) {
                        vm.$message('桌面推送功能已启动！');
                  }
      	}
    }

export default _this


// WEBPACK FOOTER //
// ./src/lib/user/msg.js